import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: ${props => (props.$isOrder ? '10%' : '30%')};
  margin-bottom: ${props => (props.$isOrder ? '10%' : '0')};
`;

export const IconBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
  border-radius: 50%;
  background: ${props => props.theme.brand.surface};
  border: 1.5px solid rgba(23, 26, 29, 0.06);

  @media screen and (min-width: 768px) {
    width: 104px;
    height: 104px;
    margin-bottom: 20px;
  }
`;

export const CartIcon = styled.svg`
  width: 40px;
  height: 40px;
  fill: ${props => props.theme.brand.accentSoft};

  @media screen and (min-width: 768px) {
    width: 52px;
    height: 52px;
  }
`;

export const Text = styled.p`
  font-family: ${props => props.theme.fonts.body};
  font-size: 14px;
  color: ${props => props.theme.brand.muted};

  @media screen and (min-width: 768px) {
    font-size: 16px;
  }
`;

export const Button = styled.button`
  padding: 14px 32px;
  margin-top: 20px;
  border: none;
  border-radius: ${props => props.theme.radii.pill};
  font-family: ${props => props.theme.fonts.body};
  font-weight: 600;
  font-size: 14px;
  color: ${props => props.theme.colors.textPrimary};
  background: ${props => props.theme.colors.secondary};
  cursor: pointer;
  transition: ${props => props.theme.transition.main};

  &:hover,
  &:focus-visible {
    background: ${props => props.theme.colors.hoverColor};
  }

  @media screen and (min-width: 768px) {
    padding: 16px 40px;
    margin-top: 28px;
    font-size: 16px;
  }
`;
